import React, { useEffect, useState } from 'react';
import ReactDOM from "react-dom";
import 'bootstrap/dist/css/bootstrap.css'
import { Select, Input } from 'antd';
import { getLabList } from "../../api/api";
import { getParsicUser } from "../../api/api";
import { errorNotify } from "../../services/toast.notification";
import { sucessNotify } from "../../services/toast.notification";
import { getLabWhiteList } from '../../api/api';
import { addLabWhiteList } from '../../api/api';
import { deleteLabWhiteList } from '../../api/api';
import { editLabWhiteList } from '../../api/api';
import Spinner from "../../components/_common/Spinner";
import editIcon  from "../../edit.svg"
import deleteIcon  from "../../trash.svg"


const LabWhiteList = () => {

    const [LabData, setLabData] = useState<any []>([]);
    const [UserData, setUserData] = useState<any []>([]);
    const [whiteList, setWhiteList] = useState<any []>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedLab, setSelectedLab] = useState<number | null>(null);
    const [selectedUser, setSelectedUser] = useState<number | null>(null);
    const [firstIP, setFirstIP] = useState("");
    const [secondIP, setSecondIP] = useState("");
    const [thirdIP, setThirdIP] = useState("");
    const [fourthIP, setFourthIP] = useState("");
    const [isEdit, setIsEdit] = useState(false);
    const [editRecordId, setEditRecordId] = useState<number>(0);
    const [currentPage, setCurrentPage] = useState(1);

    const _getLabList = () => {
        setIsLoading(true);
        getLabList()
            .then((result: any) => {
                setLabData(result.data.data);
                setIsLoading(false);
                //console.log('backup info is: '+ result.data.json);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }

    const _getLabName = (id: number) =>{
         var n = LabData.find(x => x.prk_AndriodLab_AutoID == id)
        if(n)
            return n.str_LabPersianName
        else
            return ""
    }

    const _getParsicUser = () => {
        setIsLoading(true);
        getParsicUser()
            .then((result: any) => {
                setUserData(result.data.data);
                setIsLoading(false);
                //console.log('backup info is: '+ result.data.json);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }

    const _getUserName = (id: number) => {
        var n = UserData.find(x => x.prk_ParsicUser_AutoID == id)
        if(n)
            return n.str_FullName
        else
            return ""
    }

    const _getLabWhiteList = () => {
        setIsLoading(true);
        getLabWhiteList()
            .then((result: any) => {
                setWhiteList(result.data);
                setIsLoading(false);
                //console.log('backup info is: '+ result.data.json);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }

    const _resetForm = () =>{
        setSelectedLab(null)
        setSelectedUser(null)
        setFirstIP("")
        setSecondIP("")
        setThirdIP("")
        setFourthIP("")
        setIsEdit(false)
    }

    const _addLabWhiteList = () =>{
        setIsLoading(true);
        if(selectedLab && selectedUser)
            addLabWhiteList(selectedLab , selectedUser ,firstIP ,secondIP , thirdIP , fourthIP)
                .then((result: any) => {
                    console.log(result)
                    setIsLoading(false);
                    //console.log('backup info is: '+ result.data.json);
                    _getLabWhiteList()
                    _resetForm()
                    sucessNotify("ثبت اطلاعات با موفقیت انجام شد", undefined, 5000)
                })
                .catch((error) => {
                    console.log(error);
                    errorNotify(error.response.data.errorMessage, undefined, 5000)
                })
        else{
            errorNotify("لطفا آزمایشگاه و کاربر مربوطه را انتخاب نمایید", undefined, 5000)
            setIsLoading(false);
        }
    }   

    const _deleteLabWhiteList = (whiteId: number) =>{
        setIsLoading(true);
        deleteLabWhiteList(whiteId)
            .then((result: any) => {
                console.log(result)
                setIsLoading(false);
                //console.log('backup info is: '+ result.data.json);
                _getLabWhiteList()
                sucessNotify("حذف اطلاعات با موفقیت انجام شد", undefined, 5000)
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
        
    }

    const _fillForEdit = (id:number) => {
        setIsEdit(true)
        var data = whiteList.find( x => x.prK_LabWhiteList == id)
        setSelectedLab(data.frk_LabID)
        setSelectedUser(data.frk_ParsicUserId)
        setFirstIP(data.str_IP1)
        setSecondIP(data.str_IP2)
        setThirdIP(data.str_IP3)
        setFourthIP(data.str_IP4)
        setEditRecordId(data.prK_LabWhiteList)
    }

    const _editLabWhiteList = () => {
        setIsLoading(true);
        if(selectedLab && selectedUser)
            editLabWhiteList( editRecordId , selectedLab , selectedUser ,firstIP ,secondIP , thirdIP , fourthIP)
                .then((result: any) => {
                    console.log(result)
                    setIsLoading(false);
                    //console.log('backup info is: '+ result.data.json);
                    _getLabWhiteList()
                    _resetForm()
                    sucessNotify("ویرایش اطلاعات با موفقیت انجام شد", undefined, 5000)
                })
                .catch((error) => {
                    console.log(error);
                    errorNotify(error.response.data.errorMessage, undefined, 5000)
                })
        else{
            errorNotify("لطفا آزمایشگاه و کاربر مربوطه را انتخاب نمایید", undefined, 5000)
            setIsLoading(false);
        }
    }

    // start paging code
    const pageSize = 10;
    const start = (currentPage - 1) * pageSize;
    const end = start + pageSize;

    const pagingWhiteList = whiteList.slice(start, end);

    const totalPages = Math.ceil(whiteList.length / pageSize);
    //end paging code

    useEffect(() => {
        _getLabList();
        _getParsicUser()
        _getLabWhiteList()
    }, []);
    return (
        <div className='container'>
            <div className='card'>
                <div className='card-body'>
                    <div className='row'>
                        <div className="col-md-4 mb-4">
                            <label htmlFor="slcLab" className="form-label">آزمایشگاه</label>
                            <Select
                                value={selectedLab}
                                className='antdComboStyle'
                                showSearch
                                optionFilterProp="label"
                                placeholder="انتخاب کنید"
                                options={LabData.map((item: any) => ({
                                    value: item.prk_AndriodLab_AutoID,
                                    label: item.str_LabPersianName
                                }))}
                                onChange={(value) => setSelectedLab(value)}
                            />
                        </div>
                        <div className="col-md-4 mb-4">
                            <label htmlFor="slcLab" className="form-label">کاربر مربوطه</label>
                            <Select
                                value={selectedUser}
                                className='antdComboStyle'
                                showSearch
                                optionFilterProp="label"
                                placeholder="انتخاب کنید"
                                options={UserData.map((item: any) => ({
                                    value: item.prk_ParsicUser_AutoID,
                                    label: item.str_FullName
                                }))}
                                onChange={(value) => setSelectedUser(value)}
                            />
                        </div>
                        <div className='col-md-4 mb-4'>
                            <label htmlFor='' className='form-label'>IP اول</label>
                            <Input
                                value={firstIP}
                                onChange={(e) => {
                                    const x = e.target.value;
                                    if (/^[0-9.]*$/.test(x)) {
                                        setFirstIP(x);
                                    }
                                }}
                                placeholder='ip اول را وارد کنید'
                            />
                        </div>
                        <div className='col-md-4 mb-4'>
                            <label htmlFor='' className='form-label'>IP دوم</label>
                            <Input
                                value={secondIP}
                                onChange={(e) => {
                                    const x = e.target.value;
                                    if (/^[0-9.]*$/.test(x)) {
                                        setSecondIP(x);
                                    }
                                }}
                                placeholder='ip دوم را وارد کنید'
                            />
                        </div>
                        <div className='col-md-4 mb-4'>
                            <label htmlFor='' className='form-label'>IP سوم</label>
                            <Input
                                value={thirdIP}
                                onChange={(e) => {
                                    const x = e.target.value;
                                    if (/^[0-9.]*$/.test(x)) {
                                        setThirdIP(x);
                                    }
                                }}
                                placeholder='ip سوم را وارد کنید'
                            />
                        </div>
                        <div className='col-md-4 mb-4'>
                            <label htmlFor='' className='form-label'>IP چهارم</label>
                            <Input
                                value={fourthIP}
                                onChange={(e) => {
                                    const x = e.target.value;
                                    if (/^[0-9.]*$/.test(x)) {
                                        setFourthIP(x);
                                    }
                                }}
                                placeholder='ip چهارم را وارد کنید'
                            />
                        </div>
                        <div className='col-md-12 d-flex justify-content-end'>
                            <button type="button" className="ant-btn ant-btn-danger mx-2" onClick={_resetForm}>انصراف</button>
                            <button type="button" className={isEdit ? "ant-btn ant-btn-warning" : "ant-btn ant-btn-success"} onClick={isEdit ? _editLabWhiteList : _addLabWhiteList}>
                                {isEdit ? "ویرایش" : "ثبت"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
             <div className="card">
                {  isLoading === false  && (
                <div className='card-body'>
                    <div className="table-responsive">
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th className='text-center'>ردیف</th>
                                    <th className='text-center'>آزمایشگاه</th>
                                    <th className='text-center'>کاربر</th>
                                    <th className='text-center'>IP اول</th>
                                    <th className='text-center'>IP دوم</th>
                                    <th className='text-center'>IP سوم</th>
                                    <th className='text-center'>IP چهارم</th>
                                    <th className='text-center'>عملیات</th>
                                </tr>
                            </thead>
                            <tbody className="table-border-bottom-0">
                                {
                                    pagingWhiteList.map((item: any , index) => (
                                        <tr>
                                            <td className='text-center' data-label="ردیف">{ ((currentPage - 1) * pageSize) + index + 1}</td>
                                            <td className='text-center' data-label="آزمایشگاه">{
                                                _getLabName(item.frk_LabID)
                                            }</td>
                                            <td className='text-center' data-label="کاربر">{
                                                _getUserName(item.frk_ParsicUserId)
                                            }</td>
                                            <td className='text-center' data-label="IP اول">{item.str_IP1}</td>
                                            <td className='text-center' data-label="IP دوم">{item.str_IP2}</td>
                                            <td className='text-center' data-label="IP سوم">{item.str_IP3}</td>
                                            <td className='text-center' data-label="IP چهارم">{item.str_IP4}</td>
                                            <td className='text-center' data-label="عملیات">
                                                <div>
                                                    <button type="button" className="ant-btn btn-icon ant-btn-warning mx-2" onClick={() => _fillForEdit(item.prK_LabWhiteList)}>
                                                        <img src={editIcon} alt='edit icon unloaded'/>
                                                    </button>
                                                    <button type="button" className="ant-btn btn-icon ant-btn-danger" onClick={() => _deleteLabWhiteList(item.prK_LabWhiteList)}>
                                                        <img src={deleteIcon} alt='edit icon unloaded'/>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                        <div className='pagination'>
                            <button
                                disabled={currentPage === 1}
                                className='goToPage goPrev'
                                onClick={() => setCurrentPage(currentPage - 1)}>
                                قبلی
                            </button>

                            {[...Array(totalPages)].map((_, index) => (
                                <button
                                    key={index}
                                    className={currentPage === index + 1 ? "pageLink active" : "pageLink"}
                                    onClick={() => setCurrentPage(index + 1)}>
                                    {index + 1}
                                </button>
                            ))}

                            <button
                                disabled={currentPage === totalPages}
                                className='goToPage goNext'
                                onClick={() => setCurrentPage(currentPage + 1)}>
                                بعدی
                            </button>
                        </div>
                    </div>
                </div>
                )}
                {
                    isLoading === true  && (<Spinner />)
                }
            </div>
        </div>
    );
}

export default LabWhiteList